import React from 'react';
import { Link } from 'react-router-dom';
const queryString = require('query-string');

class BackNavigationButton extends React.Component {
  render() {
    const {
      defaultPath = 'Festivals',
      queryPrefix = 'Festival/',
      prefixFor = [],
      className = 'btn btn-info btn-sm',
      title = 'Back'
    } = this.props;

    const parsed = queryString.extract(window.location.search);
    const shouldPrefix = parsed && prefixFor.indexOf(parsed) > -1;
    const url = parsed ? (shouldPrefix ? queryPrefix + parsed : parsed) : defaultPath;

    return (
      <Link to={`/Admin/${url}?restore_page=true`} className={className} title={title}>
        <i className="fa fa-arrow-left" aria-hidden="true" />
      </Link>
    );
  }
}

export default BackNavigationButton;



// WEBPACK FOOTER //
// ./src/components/ThemeComponents/BackNavigationButton.jsx